export const getToken = () => {
  let encodedToken = localStorage.getItem('token') || '';
  if (!encodedToken) return '';
  try {
    return atob(encodedToken.slice(10));
  } catch (e) {
    console.error('Invalid Token:', e);
    return '';
  }
};

export const getBiometricToken = () => {
  let encodedToken = localStorage.getItem('biometricToken') || '';
  if (encodedToken) {
    return atob(encodedToken.slice(10));
  }
  return '';
};
